import actions from './actions';
import mutations from './mutations';

export default {
  state: {
    allUnitDimensions: null,
    buyers: [],
    curators: [],
    dataProviders: [],
    demographics: [],
    externalDemographics: [],
    iabCategories: [],
    languages: [],
    locations: [],
    locationTreeSearchResults: [],
    markets: [],
    mediaOwnerCountryRoots: null,
    mediaOwners: [],
    mediaTypes: [],
    networks: [],
    organizationDSPIDs: [],
    organizationDSPs: [],
    organizationExternalExchanges: [],
    sites: [],
  },
  mutations,
  actions,
  getters: {
    countries: (state) => state.locations.filter((x) => x.level === 0),
  },
};
